import { render, staticRenderFns } from "./AddTest.vue?vue&type=template&id=420a3daa&scoped=true"
import script from "./AddTest.vue?vue&type=script&lang=js"
export * from "./AddTest.vue?vue&type=script&lang=js"
import style0 from "./AddTest.vue?vue&type=style&index=0&id=420a3daa&prod&scoped=true&lang=css"
import style1 from "./AddTest.vue?vue&type=style&index=1&id=420a3daa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420a3daa",
  null
  
)

export default component.exports